// extracted by mini-css-extract-plugin
export default {"container":"GM8To_UF","pencil":"ECE2Cvwp"};